module.exports = __webpack_public_path__ + "static/media/spartificial.49f25059.jpg";